import React from 'react';
import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import { Button, CardActions, CardContent, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { useAppContext } from '@/context';
import { useFRCallback } from '@/hooks';

const VerifiedEmail = ({ stepToRender, setCurrentStep }) => {
  const { setLoading } = useAppContext();
  const { callbacks, confirmationCallbackIndex, confirmationCallbackOptions } = useFRCallback(stepToRender);

  const handleNavigation = async () => {
    setLoading(true);

    const nextStep = { ...stepToRender };
    const newCallbacks = [...callbacks];

    // the 'yes' option in the journey is '0' and should forward the user back to login
    const yesIndex = findIndex(confirmationCallbackOptions, (button) => button?.toLowerCase() === 'yes');

    newCallbacks[confirmationCallbackIndex].input[0] = {
      ...newCallbacks[confirmationCallbackIndex].input[0],
      value: yesIndex,
    };

    // set the newCallbacks in the newStep
    Object.assign(nextStep.payload.callbacks, newCallbacks);

    // update the currentStep to trigger navigation
    setCurrentStep({ ...nextStep });

    setLoading(false);
  };

  return (
    <Grid
      id="verified-email-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        size={{ xs: 12, sm: 12, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        sx={{ minHeight: '100vh' }}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '600px' } }}>
            <CardContent>
              <Typography variant="h1" mb={2}>
                Your email address has been validated.
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'end' }}>
              <Button color="primary" onClick={handleNavigation}>
                Proceed to Login
              </Button>
            </CardActions>
          </Paper>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

VerifiedEmail.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default VerifiedEmail;
